import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "dest"];

  static values = {
    option: String,
    initialOption: String,
  };

  static classes = ["hide"];

  connect() {
    if (this.initialOptionValue) {
      this.toggleState(this.initialOptionValue);
    } else {
      this.toggleState(this.sourceTarget.value);
    }
  }

  toggle(event) {
    this.toggleState(event.target.value);
  }

  toggleState(value) {
    this.destTargets.forEach((t) => {
      if (this.optionValue === value) {
        t.classList.remove(this.hideClass);
        // Enable the field when shown
        this.enableFields(t);
      } else {
        t.classList.add(this.hideClass);
        // Disable the field when hidden and clear its value and validation state
        this.disableFields(t);
      }
    });
  }

  enableFields(container) {
    const fields = container.querySelectorAll("input, select, textarea");
    fields.forEach((field) => {
      field.disabled = false;
    });
  }

  disableFields(container) {
    const fields = container.querySelectorAll("input, select, textarea");
    fields.forEach((field) => {
      field.disabled = true;
      field.value = "";
      // Clear custom validation state
      field.setCustomValidity("");
    });
  }
}
